import * as React from 'react';
import { useState } from 'react';
import { Col, Row, Form, Nav, Card, Button, ListGroup, Badge, Alert, Modal, Spinner } from "react-bootstrap";
import * as yup from 'yup';
import * as formik from 'formik';
import atlasApi from "../utils/atlasapi";
import schemas from "../data/dataSchemas";
import TagSelector from "../components/TagSelector";


export interface diagProps {
	setup: (value: string) => void;
	onClose: (value: string) => void;
	onConfirm: (value: string) => void;
	onAfter: object;
}

export default function DialogSaveScenario(props: diagProg) {
		
	const { onClose, onConfirm, setup } = props;
	
	const [status, setStatus] = useState({sent:null, message:'', rename:setup.rename});
	
	const { Formik } = formik;
	const handleClose = (result) => {
		onClose(result);
		if(setup.onAfter)
			setup.onAfter(result);
		setStatus({sent:null, success:false, message:''});
	};
	const scenario = setup.scenario;
	const user = setup.user;

	const handleConfirm = () => {
		setStatus({sent:false, success:false, message:'Saving...'});

		if(!scenario.scenario_id && !scenario.scenarioid)
			return;

		const pId = scenario.projectid;
		const sId = scenario.scenario_id ?? scenario.scenarioid;

		atlasApi.editScenario(pId, sId, {
			name:     scenario.name,
			tag:      scenario.tag ?? null,
		}).then((response) => {
			const id = response?.scenario_id ?? response?.scenarioid ?? response?.name;
			if(id){
				setStatus({sent:true, success:true, message:'Your scenario was saved'});
				if(setup.onAfter){
					setup.onAfter(response);
					setTimeout(()=>{
						onClose();
						setStatus({sent:null, message:'', rename:setup.rename});
					}, 1000);
				} else {
					setTimeout(() => {
						setStatus({sent:null, message:'', rename:setup.rename});
					}, 2000);
				}
			} else {
				setStatus({sent:true, success:false, message:'Error saving scenario'});
			}
		}).catch(() => {
			setStatus({sent:true, success:false, message:'Error saving scenario'});
		});
	};
	const handleSubmit = (data)=>{

		scenario.name = data.name;
		scenario.tag = data?.tag?.name ? data.tag : null;
		handleConfirm();
	};
	
	
	
	const handleOnShow = ()=>{
		
		if(setup.prompt || setup.rename)
			return false;
		else
			handleConfirm();
		
	}
	if(!scenario)
		return '';

	return (
		<Modal show={setup.open} onHide={handleClose} onShow={handleOnShow} centered className="scenario-dialog">
			<Modal.Header>
				<Modal.Title>{setup.rename ? 'Edit' : 'Save'} Scenario</Modal.Title>
			</Modal.Header>

			
				<Formik validationSchema={schemas.scenario} onSubmit={(a,b)=>handleSubmit(a,b)} initialValues={{name:scenario.name, tag:scenario.tag}}>	
					{({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
						<Form noValidate onSubmit={handleSubmit}>
								
							{
								status.sent === null && !setup.rename && 
									<React.Fragment>
										<Modal.Body>
											<Row className="mb-3 dialog-feedback">
												{setup.icon ? (
													<Col xs="12" className="dialog-feedback-icon text-center">
														<i className={setup.icon.class + ' text-' + setup.icon.color} />
													</Col>							
												) : ''}

												<Col xs="12" className="dialog-feedback-text mb-3">
													{setup.text ? setup.text : 'Are you sure you want to proceed?'}
												</Col>
											</Row>
										</Modal.Body>
										<Modal.Footer>
											<Button className="me-auto" onClick={handleClose} variant="secondary">{setup.btnCloseText ? setup.btnCloseText : 'Close'}</Button>
											<Button onClick={handleConfirm} variant="success">{setup.btnSaveText ? setup.btnSaveText : 'Save scenario'}</Button>
										</Modal.Footer>
									</React.Fragment>
							}
							{	status.sent === null && setup.rename &&
									<React.Fragment>
										<Modal.Body>
											
											<Row className="mb-3">
												<Form.Group as={Col} md="12">
													<Form.Label>Name</Form.Label>
													<Form.Control type="text" name="name" placeholder="Input scenario name"   value={values.name} onChange={handleChange} isValid={touched.name && !errors.name} isInvalid={errors.name}/>
												</Form.Group>

												<Form.Control.Feedback>
													{errors.name}
												</Form.Control.Feedback>
											</Row>
											<TagSelector projectid={scenario.projectid} value={values.tag} onChange={(v)=>{setFieldValue("tag",v)}}/>
										</Modal.Body>
										<Modal.Footer>
											<Button className="me-auto" onClick={handleClose} variant="outline-primary">{setup.btnCloseText ? setup.btnCloseText : 'Close'}</Button>
											<Button  type="submit" variant="primary">{setup.btnSaveText ? setup.btnSaveText : 'Save scenario'}</Button>
										</Modal.Footer>
									</React.Fragment>
							}	
							{	status.sent !== null && 
									<Modal.Body>
										<Row className="mb-3 dialog-feedback">
											<Col xs="12" className="dialog-feedback-icon text-center">
												{
												status.sent ?
													(status.success ? 
														(<i className="ri-checkbox-circle-line text-success"></i>)
														:
														(<i className="ri-error-warning-line text-warning"></i>)
													)
													:
													(<Spinner animation="border" variant="info" className="mt-5" />)
												}
											</Col>
											<Col xs="12" className="dialog-feedback-text mb-5">
												{status.message}
											</Col>
										</Row>
									</Modal.Body>	

							}		
						</Form>
					)}	
				</Formik>	
		</Modal>
	);
} 
